import { useState } from "react"
import CursorCustom from "../../../tools/CursorCustom";


function PartServiceItem({ children }) {
    const isTouch = typeof window !== "undefined" && matchMedia("(hover: none)").matches;
    const [active, setActive] = useState(false);


    return (
        <div
            className={`part-service-container ${active ? "part-service-active" : ""}`}
            onClick={isTouch ? undefined : () => setActive(a => !a)}
            onMouseLeave={isTouch ? undefined : () => setActive(false)}
        >
            {children}
        </div>
    );
}

export default function Service() {
    const [hover, setHover] = useState(false);
    return (
        <>
            <CursorCustom active={hover} />
            <div className="service-container"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >

                <PartServiceItem>
                    <div className="part-container">
                        <div className="part-left-container">
                            <div className="part-titles-container">
                                <div className="part-title-container">
                                    <h2 className="part-title karrik f96">Stratégie</h2>
                                    <div className="part-icons-container">
                                        <div className="icons-black-container target-container">
                                            <img className="target" src="./img/services-icons/black/target.png" alt="Icon de stratégie" />
                                        </div>
                                        <div className="dart-container">
                                            <img className="dart" src="./img/services-icons/black/dart.png" alt="Icon stratégie" />
                                        </div>
                                        <img src="./img/services-icons/blue/dart.png" alt="Icon stratégie" className="dart-active dart-active-one " />
                                        <img src="./img/services-icons/blue/dart.png" alt="Icon stratégie" className="dart-active dart-active-two " />
                                    </div>
                                </div>
                                <h4 className="part-subtitle sansita f30">Définissons ensemble vos objectifs</h4>
                            </div>

                        </div>
                        <div className="part-right-container">
                            <div className="part-right-text-container">
                                <p className="f20">
                                    On commence par analyser vos objectifs et votre marché afin de définir une ligne claire pour votre projet digital. Chaque décision est guidée par vos besoins réels et une compréhension précise de vos utilisateurs, pour bâtir une base solide et cohérente. la compréhension des utilisateurs et l’étude des enjeux permettent de poser des fondations solides.
                                </p>
                            </div>
                            <div className="part-right-shadow">
                            </div>
                        </div>
                    </div>
                </PartServiceItem>
                <PartServiceItem>
                    <div className="part-container">
                        <div className="part-left-container">
                            <div className="part-titles-container">
                                <div className="part-title-container">
                                    <h2 className="part-title karrik f96">Design</h2>
                                    <div className="part-icons-container">
                                        <div className="plume-container icons-black-container">
                                            <img className="plume" src="./img/services-icons/black/plume.png" alt="Icon de stratégie" />
                                        </div>
                                    </div>
                                </div>
                                <h4 className="part-subtitle f30 sansita">Un design percutant et pertinent</h4>
                            </div>

                        </div>
                        <div className="part-right-container">
                            <div className="part-right-text-container">
                                <p className="f20">Un soin particulier est apporté à la conception visuelle. Des expériences visuelles immersives, élégantes et fonctionnelles. L’esthétique n’est pas seulement une question de style, mais un outil stratégique pour valoriser votre image et renforcer l’impact de votre message auprès de votre audience.</p>
                            </div>
                            <div className="part-right-shadow">
                            </div>
                        </div>
                    </div>
                </PartServiceItem>
                <PartServiceItem>
                    <div className="part-container">
                        <div className="part-left-container">
                            <div className="part-titles-container">
                                <div className="part-title-container">
                                    <h2 className="part-title karrik f96">Code</h2>
                                    <div className="part-icons-container keyboard-icons-container">
                                        <div className="keyboard-container icons-black-container">
                                            <img className="keyboard" src="./img/services-icons/black/keyboard-d.png" alt="Icon de stratégie" />
                                            <img className="keyboard-hole" src="./img/services-icons/black/keyboard-hole.png" alt="Icon de stratégie" />
                                        </div>
                                        <div className="keyboard-container icons-black-container">
                                            <img className="keyboard key-e" src="./img/services-icons/black/keyboard-e.png" alt="Icon de stratégie" />
                                            <img className="keyboard-hole" src="./img/services-icons/black/keyboard-hole.png" alt="Icon de stratégie" />
                                        </div>
                                        <div className="keyboard-container icons-black-container">
                                            <img className="keyboard" src="./img/services-icons/black/keyboard-v.png" alt="Icon de stratégie" />
                                            <img className="keyboard-hole" src="./img/services-icons/black/keyboard-hole.png" alt="Icon de stratégie" />
                                        </div>
                                    </div>
                                </div>
                                <h4 className="part-subtitle f30 sansita">Un code maintenable, évolutif et sécurisé</h4>
                            </div>

                        </div>
                        <div className="part-right-container">
                            <div className="part-right-text-container">
                                <p className="f20">Le développement repose sur des technologies modernes et performantes. Chaque fonctionnalité est pensée pour être fluide, sécurisée et évolutive afin de garantir une experience utilisateur sans compromis. Le code devient un outil de précision, garantissant à la fois stabilité technique et liberté créative.</p>
                            </div>
                            <div className="part-right-shadow">
                            </div>
                        </div>
                    </div>
                </PartServiceItem>
            </div>
        </>
    )
}